export const getLabelFromConditionsValuemap = {
	eq: 'EQUALS',
	ne: 'NOT_EQUALS',
	in: 'IN',
	ni: 'NOT_IN',
	contains: 'CONTAINS',
	not_contains: 'NOT_CONTAINS',
};
